import React, { Suspense } from 'react';
import LoadingScreen from '~/components/screens/LoadingScreen';

const BasicLineChartComponent = React.lazy(
    () => import(/* webpackChunkName: "basicChart" */ '~/modules/basicChart/BasicLineChart')
);

type Props = {
    data?: number[];
    fromNumber?: number;
    chartColor: string;
    isLarge: boolean;
};
export default function BasicLineChart({ data, fromNumber, chartColor, isLarge }: Props) {
    return (
        <Suspense fallback={<LoadingScreen />}>
            <BasicLineChartComponent data={data} fromNumber={fromNumber} chartColor={chartColor} isLarge={isLarge} />
        </Suspense>
    );
}
